import OBJ0 from "../assets/truck/shape0_0.obj";
import OBJ1 from "../assets/truck/shape0_1.obj";
import OBJ2 from "../assets/truck/shape0_2.obj";
import OBJ3 from "../assets/truck/shape0_3.obj";
import OBJ4 from "../assets/truck/shape0_4.obj";
import OBJ5 from "../assets/truck/shape0_5.obj";
import OBJ6 from "../assets/truck/shape0_6.obj";
import OBJ7 from "../assets/truck/shape0_7.obj";

import OBJ8 from "../assets/truck/shape1_0.obj";
import OBJ9 from "../assets/truck/shape1_1.obj";
import OBJ10 from "../assets/truck/shape1_2.obj";
import OBJ11 from "../assets/truck/shape1_3.obj";
import OBJ12 from "../assets/truck/shape1_4.obj";
import OBJ13 from "../assets/truck/shape1_5.obj";
import OBJ14 from "../assets/truck/shape1_6.obj";
import OBJ15 from "../assets/truck/shape1_7.obj";

import OBJ16 from "../assets/truck/shape2_0.obj";
import OBJ17 from "../assets/truck/shape2_1.obj";
import OBJ18 from "../assets/truck/shape2_2.obj";
import OBJ19 from "../assets/truck/shape2_3.obj";
import OBJ20 from "../assets/truck/shape2_4.obj";
import OBJ21 from "../assets/truck/shape2_5.obj";
import OBJ22 from "../assets/truck/shape2_6.obj";
import OBJ23 from "../assets/truck/shape2_7.obj";

import OBJ24 from "../assets/truck/shape3_0.obj";
import OBJ25 from "../assets/truck/shape3_1.obj";
import OBJ26 from "../assets/truck/shape3_2.obj";
import OBJ27 from "../assets/truck/shape3_3.obj";
import OBJ28 from "../assets/truck/shape3_4.obj";
import OBJ29 from "../assets/truck/shape3_5.obj";
import OBJ30 from "../assets/truck/shape3_6.obj";
import OBJ31 from "../assets/truck/shape3_7.obj";

import PNG0 from "../assets/truck/shape0.pngfeat0.png";
import PNG1 from "../assets/truck/shape0.pngfeat1.png";
import PNG2 from "../assets/truck/shape1.pngfeat0.png";
import PNG3 from "../assets/truck/shape1.pngfeat1.png";
import PNG4 from "../assets/truck/shape2.pngfeat0.png";
import PNG5 from "../assets/truck/shape2.pngfeat1.png";
import PNG6 from "../assets/truck/shape3.pngfeat0.png";
import PNG7 from "../assets/truck/shape3.pngfeat1.png";

import JSON from "../assets/truck/mlp.json";

const TRUCK = [
  OBJ0,
  OBJ1,
  OBJ2,
  OBJ3,
  OBJ4,
  OBJ5,
  OBJ6,
  OBJ7,
  OBJ8,
  OBJ9,
  OBJ10,
  OBJ11,
  OBJ12,
  OBJ13,
  OBJ14,
  OBJ15,
  OBJ16,
  OBJ17,
  OBJ18,
  OBJ19,
  OBJ20,
  OBJ21,
  OBJ22,
  OBJ23,
  OBJ24,
  OBJ25,
  OBJ26,
  OBJ27,
  OBJ28,
  OBJ29,
  OBJ30,
  OBJ31,
  PNG0,
  PNG1,
  PNG2,
  PNG3,
  PNG4,
  PNG5,
  PNG6,
  PNG7,
  JSON,
];

export default TRUCK;
